// B-3: thumbnail overlays for the LIVE card variant.
//
// Rendered inside StreamCard's thumbnail slot (which is position:relative),
// alongside the <img>:
//   <StreamCard thumbnail={<><img … /><LiveBadges viewerCount={n} /></>}>
//
// Exactly ONE live indicator is drawn by the app — this badge. Source
// thumbnails sometimes have LIVE burned into the image; we accept that
// duplication rather than drawing a second app badge.
//
// The badge dot does NOT animate — only the section header dot pulses
// (12 pulsing dots across the grid is too much motion).
//
// Watchers are concurrent viewers; the pill reads "1.2K watching", never
// "views". All colors come from the browse-* tokens (raw hex fails the
// designTokens jest check).
import React from 'react';
import { RisingIcon } from './icons';
import { formatWatchers } from './format';

/**
 * @param {Object} props
 * @param {?number} props.viewerCount  concurrent watchers; the pill is
 *   hidden when null (unreported) or 0 — nothing ever renders "0 watching"
 * @param {?boolean} props.surging  Rising flag (server-gated); the badge renders
 *   ONLY on an explicit true — false or absent (kill switch off) draws nothing
 */
const LiveBadges = ({ viewerCount, surging }) => (
  <>
    <span className="absolute left-2.25 top-2.25 flex h-[22px] items-center gap-1.25 rounded-badge bg-browse-live px-2 font-inter-tight text-10 font-semibold leading-none tracking-badge-live text-white">
      <span aria-hidden="true" className="h-1.25 w-1.25 rounded-full bg-white" />
      LIVE
    </span>
    {surging === true && (
      // Rising: same badge shape/size as LIVE, top-right (top-left is
      // LIVE's corner; bottom-right is the watcher pill's). Angular arrow +
      // amber = two separation channels from LIVE's round red dot. Static
      // after a single 200ms entrance fade — LIVE owns the only heartbeat.
      <span
        role="img"
        aria-label="Rising — viewers increasing fast"
        className="absolute right-2.25 top-2.25 flex h-[22px] animate-badge-in items-center gap-1 rounded-badge bg-browse-rising px-2 font-inter-tight text-10 font-semibold leading-none tracking-badge-live text-browse-text-primary"
      >
        <RisingIcon aria-hidden="true" />
        Rising
      </span>
    )}
    {viewerCount != null && viewerCount > 0 && (
      <span className="absolute bottom-2.25 right-2.25 flex h-[21px] items-center rounded-badge bg-browse-scrim px-1.75 font-inter-tight text-11 font-medium leading-none text-white">
        {formatWatchers(viewerCount)} watching
      </span>
    )}
  </>
);

export default LiveBadges;
